/**
 * @generated SignedSource<<b0923144544ac1ba24a260381ba3985e>>
 * @relayHash 4631371f14e261e16fcd140764be698f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 686e6d140e6c79a450a1c1571ee8aa05ca14805d9a705483c0ac7034340a8c31

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type proposalActivityPageQuery$variables = {
  accountSlug: string;
  proposalId: string;
};
export type proposalActivityPageQuery$data = {
  readonly accountBySlug: {
    readonly " $fragmentSpreads": FragmentRefs<"reviewersCardOptionsFragment">;
  };
  readonly schemaProposal: {
    readonly id: string;
    readonly viewerIsReviewer: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"eventsTimelineProposalCommentsFragment" | "reviewersCardCurrentValueFragment">;
  };
  readonly viewer: {
    readonly avatarUrl: string | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"eventsTimelineProposalUserFragment">;
  };
};
export type proposalActivityPageQuery = {
  response: proposalActivityPageQuery$data;
  variables: proposalActivityPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountSlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "accountSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "proposalId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsReviewer",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v7/*: any*/),
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "SchemaProposalReply",
  "kind": "LinkedField",
  "name": "replies",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v14/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolved",
  "storageKey": null
},
v17 = [
  (v7/*: any*/),
  (v2/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "resolvedBy",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "proposalActivityPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "reviewersCardOptionsFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "eventsTimelineProposalUserFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*: any*/),
          "concreteType": "SchemaProposal",
          "kind": "LinkedField",
          "name": "schemaProposal",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "eventsTimelineProposalCommentsFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "reviewersCardCurrentValueFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "proposalActivityPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SchemaProposal",
        "kind": "LinkedField",
        "name": "schemaProposal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activityFeed",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isSchemaProposalActivityFeedItem"
              },
              {
                "kind": "InlineFragment",
                "selections": (v13/*: any*/),
                "type": "SchemaProposalApproval",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v13/*: any*/),
                "type": "SchemaProposalRejection",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v15/*: any*/)
                ],
                "type": "SchemaProposalCommentOnProposal",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v15/*: any*/)
                ],
                "type": "SchemaProposalCommentOnSdl",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "line",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subgraphName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "diffSide",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "contextLines",
                        "value": 5
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": "context(contextLines:5)"
                  },
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v15/*: any*/)
                ],
                "type": "SchemaProposalCommentOnLine",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "SchemaProposalRevision",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v19/*: any*/),
                "type": "SchemaProposalReviewRequest",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "reviewers",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "onBehalfOf",
                    "plural": true,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "type": "SchemaProposalReviewerUser",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "SchemaProposalReviewerTeam",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4631371f14e261e16fcd140764be698f",
    "id": "686e6d140e6c79a450a1c1571ee8aa05ca14805d9a705483c0ac7034340a8c31",
    "metadata": {},
    "name": "proposalActivityPageQuery",
    "operationKind": "query",
    "text": "query proposalActivityPageQuery(\n  $accountSlug: String!\n  $proposalId: ID!\n) {\n  accountBySlug(slug: $accountSlug) {\n    __typename\n    ...reviewersCardOptionsFragment\n    id\n  }\n  viewer {\n    id\n    avatarUrl\n    ...eventsTimelineProposalUserFragment\n  }\n  schemaProposal(id: $proposalId) {\n    id\n    viewerIsReviewer\n    ...eventsTimelineProposalCommentsFragment\n    ...reviewersCardCurrentValueFragment\n  }\n}\n\nfragment eventsTimelineContextProviderFragment on SchemaProposal {\n  id\n  reviewers {\n    __typename\n    ... on SchemaProposalReviewerUser {\n      __typename\n      user {\n        id\n      }\n      onBehalfOf {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment eventsTimelineProposalCommentFragment on SchemaProposalActivityFeedItem {\n  __isSchemaProposalActivityFeedItem: __typename\n  ... on SchemaProposalApproval {\n    __typename\n    ...eventsTimelineProposalReviewerApprovalFragment\n  }\n  ... on SchemaProposalRejection {\n    __typename\n    ...eventsTimelineProposalReviewerRejectionFragment\n  }\n  ... on SchemaProposalCommentOnProposal {\n    __typename\n    ...eventsTimelineProposalCommentOnProposalFragment\n  }\n  ... on SchemaProposalCommentOnSdl {\n    __typename\n    ...eventsTimelineProposalCommentOnSdlFragment\n  }\n  ... on SchemaProposalCommentOnLine {\n    __typename\n    ...eventsTimelineProposalCommentOnLineFragment\n  }\n  ... on SchemaProposalRevision {\n    __typename\n    ...eventsTimelineProposalRevisionFragment\n  }\n}\n\nfragment eventsTimelineProposalCommentOnLineFragment on SchemaProposalCommentOnLine {\n  id\n  text\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n  line\n  subgraphName\n  diffSide\n  context(contextLines: 5)\n  resolved\n  resolvedBy {\n    name\n    id\n  }\n  replies {\n    id\n    text\n    createdAt\n    author {\n      id\n      name\n      avatarUrl\n    }\n  }\n}\n\nfragment eventsTimelineProposalCommentOnProposalFragment on SchemaProposalCommentOnProposal {\n  id\n  text\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n  replies {\n    id\n    text\n    createdAt\n    author {\n      id\n      name\n      avatarUrl\n    }\n  }\n}\n\nfragment eventsTimelineProposalCommentOnSdlFragment on SchemaProposalCommentOnSdl {\n  id\n  text\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n  resolved\n  resolvedBy {\n    name\n    id\n  }\n  replies {\n    id\n    text\n    createdAt\n    author {\n      id\n      name\n      avatarUrl\n    }\n  }\n}\n\nfragment eventsTimelineProposalCommentsFragment on SchemaProposal {\n  id\n  activityFeed {\n    __typename\n    ...eventsTimelineProposalCommentFragment\n    ... on SchemaProposalApproval {\n      id\n    }\n    ... on SchemaProposalCommentOnLine {\n      id\n    }\n    ... on SchemaProposalCommentOnProposal {\n      id\n    }\n    ... on SchemaProposalCommentOnSdl {\n      id\n    }\n    ... on SchemaProposalRejection {\n      id\n    }\n    ... on SchemaProposalReviewRequest {\n      id\n    }\n  }\n  ...eventsTimelineContextProviderFragment\n}\n\nfragment eventsTimelineProposalReviewerApprovalFragment on SchemaProposalApproval {\n  id\n  message\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n}\n\nfragment eventsTimelineProposalReviewerRejectionFragment on SchemaProposalRejection {\n  id\n  message\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n}\n\nfragment eventsTimelineProposalRevisionFragment on SchemaProposalRevision {\n  description\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n}\n\nfragment eventsTimelineProposalUserFragment on User {\n  id\n  name\n  avatarUrl\n}\n\nfragment reviewersCardCurrentValueFragment on SchemaProposal {\n  id\n  author {\n    id\n  }\n  reviewers {\n    __typename\n    ... on SchemaProposalReviewerUser {\n      __typename\n      status\n      user {\n        id\n        name\n        avatarUrl\n      }\n      onBehalfOf {\n        id\n        name\n      }\n    }\n    ... on SchemaProposalReviewerTeam {\n      __typename\n      team {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment reviewersCardOptionsFragment on Organization {\n  members {\n    nodes {\n      user {\n        id\n        name\n        avatarUrl\n      }\n      id\n    }\n  }\n  teams {\n    nodes {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d31afff393fc17ab323f9c911ee8bf50";

export default node;
